import { render, staticRenderFns } from "./tournamentHero.vue?vue&type=template&id=74c02ff3&scoped=true&"
import script from "./tournamentHero.vue?vue&type=script&lang=js&"
export * from "./tournamentHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c02ff3",
  null
  
)

export default component.exports